import { motion } from "framer-motion";

/**
 * Animated aurora blobs — abstract floating gradient orbs.
 * Pure CSS + framer-motion easing, GPU-friendly.
 */
export const Aurora = ({ className = "" }) => {
    return (
        <div
            className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
            aria-hidden="true"
            data-testid="aurora-bg"
        >
            <motion.div
                animate={{
                    x: [0, 60, -40, 0],
                    y: [0, -30, 40, 0],
                    scale: [1, 1.1, 0.95, 1],
                }}
                transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -top-32 -left-20 w-[55vw] h-[55vw] rounded-full blur-[120px] opacity-50"
                style={{
                    background:
                        "radial-gradient(circle at 30% 30%, rgba(59,130,246,0.55), transparent 60%)",
                }}
            />
            <motion.div
                animate={{
                    x: [0, -50, 30, 0],
                    y: [0, 40, -20, 0],
                    scale: [1, 0.9, 1.05, 1],
                }}
                transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -bottom-32 -right-24 w-[60vw] h-[60vw] rounded-full blur-[140px] opacity-40"
                style={{
                    background:
                        "radial-gradient(circle at 70% 70%, rgba(251,191,36,0.35), transparent 65%)",
                }}
            />
            <motion.div
                animate={{
                    x: [0, 30, -20, 0],
                    y: [0, -40, 20, 0],
                }}
                transition={{ duration: 26, repeat: Infinity, ease: "easeInOut" }}
                className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[40vw] h-[40vw] rounded-full blur-[120px] opacity-30"
                style={{
                    background:
                        "radial-gradient(circle, rgba(167,139,250,0.45), transparent 60%)",
                }}
            />
        </div>
    );
};
